import ajv from '@f/validation/ajv'
import * as TshirtSchema from '@f/validation/schema/datalayer/tshirt'
import { ITshirtChoice } from '@f/validation/types/dataLayer'

export const validateTshirtChoice = ajv.compile<ITshirtChoice>(TshirtSchema.TshirtChoice)